import { BaseUniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface SidebarNextUniDriver extends BaseUniDriver {
  getSelectedKey(): Promise<string>;
  getSkin(): Promise<string>;
  isHidden(): Promise<boolean>;
  headerExists(): Promise<boolean>;
  footerExists(): Promise<boolean>;
  isLoading(): Promise<boolean>;
  getWidth(): Promise<string>;
  isMinimized(): Promise<boolean>;
  clickOnMinimizeButton(): Promise<void>;
  minimizeButtonExists(): Promise<boolean>;
}
